import { Injectable, inject } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot } from "@angular/router";
import { UserStoreService } from "../services/user-store.service";
import { Observable } from "rxjs";
import { map} from "rxjs/operators";

@Injectable({
    providedIn: 'root'
})
class PermissionsService {

    constructor(private userStore: UserStoreService) { }

    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
        if (this.userStore.isLoggedIn()) {
            return this.userStore.isBusinessAdmin();
        } else {
            return this.userStore.user.pipe(map(user => user.businessAdmin));
        }
    }
}

export const CanActivateSearchGuard: CanActivateFn = (next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean => {
    return inject(PermissionsService).canActivate(next, state);
}
